module.exports = __webpack_public_path__ + "img/EC.05ca26eb.png";